import logo from './resources/images/harmonia.webp';
import './App.css';
import { WhatsappContact } from './components/whatsappContact/whatsappContact';
import SectionInfo from './components/sectionInfo/sectionInfo';
import Menu from './components/menu/menu';
import twoBlends  from './resources/images/twoBlends.jpg';
import oneBlend  from './resources/images/oneBlend.jpg';

function App() {
  return (
    <div className="App">
      <Menu></Menu>

      <main>
        <img src={logo} className="App-logo" alt="logo" />
        <SectionInfo
          title="Quem somos?"
          image={twoBlends}
          >
Temos a missão de trazer equilíbrio,
              leveza e bem-estar para o seu dia a dia.
              Sabemos como o mundo pode ser
              intenso e desafiador, e é por isso que
              oferecemos blends cuidadosamente
              desenvolvidos para ajudar você a
              encontrar a harmonia do seu corpo
              novamente utilizando menos remédios.

          </SectionInfo>

        <SectionInfo
          title="O que é?/Origem"
          image={oneBlend}>

        Blends são combinações de óleos essenciais com a
        finalidade de atender alguma necessidade
        específica, como ter mais concentração ou diminuir
        o estresse.
      
        Já os oléos essenciais são líquidos extraídos de
        plantas, contendo compostos que dão o aroma
        característico de cada uma, como o óleo de
        citronela. Eles são chamados "essenciais" porque
        trazem a "essência" da planta.
        
        A origem dos óleos essenciais é antiga, datada a
        4000 mil anos átras, usado por egípcios, chineses e
        indianos, mas o uso moderno conhecido como
        aromaterapia ganhou força na europa no século XX.

          </SectionInfo>
      </main>
      <footer>
        <div id='contact'>
          Entre em contato conosco:
          <WhatsappContact></WhatsappContact>
        </div>
      </footer>
    </div>
  );
}

export default App;
